/* src/app/pages/ui-kit/components/input-view/input-view.component.scss */
.box {
  display: flex;
  gap: 14px;
  align-items: center;
  margin-bottom: 30px;
}
/*# sourceMappingURL=input-view.component.css.map */
